<template>
  <div>
    <div class="mainBG">
      <div class="login-container">
        <div style="display: flex; justify-content: space-between; width: 100%">
          <img src="./../../assets/imgs/bgcenter.png" style="
              margin-top: 12%;
              width: 624px;
              height: 585px;
              z-index: 1000;
            " />
          <el-card class="login_card">
            <!-- 登录 -->
            <el-form style="width: 350px" autocomplete="on" :rules="rules" :model="loginForm" ref="loginForm" label-position="left" v-if="loginStatus == 1">
              <div v-show="loginWay !== 'wx'">
                <div class="title-container">
                  <div class="title" @click="posCode">客如意 | 云POS系统V2.0</div>
                </div>
                <el-form-item prop="hotelCode">
                  <span style="color: #666; font-size: 20px">酒店ID</span>
                  <el-input name="hotelCode" v-model="loginForm.hotelCode" autocomplete="on" placeholder="请输入酒店ID" />
                </el-form-item>
                <el-form-item prop="username">
                  <span style="color: #666; font-size: 20px">工号</span>
                  <el-input name="username" v-model="loginForm.username" autocomplete="on" placeholder="请输入工号" />
                </el-form-item>
                <el-form-item prop="password">
                  <span style="color: #666; font-size: 20px">密码</span>
                  <el-input name="password" :type="passwordType" v-model="loginForm.password" autocomplete="on" show-password />
                </el-form-item>

                <div style="width: 100%; display: flex; justify-content: center">
                  <el-button type="primary" style="
                      margin-top: 30px;
                      width: 340px;
                      height: 60px;
                      border-radius: 38px;
                    " :loading="loading" @click="handleLogin('loginForm')">登录</el-button>
                </div>
                <div class="remember">
                  <el-checkbox v-model="checked">记住密码</el-checkbox>
                </div>
              </div>
            </el-form>
            <!-- 修改密码 -->
            <el-form style="width: 350px" autocomplete="on" :rules="modifyPwdRules" :model="modifyForm" ref="modifyForm" label-position="left" v-if="loginStatus == 3">
              <div v-show="loginWay !== 'wx'">
                <div class="title-container">
                  <div class="title">修改密码</div>
                </div>

                <el-form-item prop="oldPwd">
                  <span style="color: #666; font-size: 20px">旧密码</span>
                  <el-input name="hotelCode" v-model="modifyForm.oldPwd" autocomplete="on" placeholder="请输入原来的密码" />
                </el-form-item>
                <el-form-item prop="newPwd">
                  <span style="color: #666; font-size: 20px">新密码</span>
                  <el-input name="username" v-model="modifyForm.newPwd" autocomplete="on" show-password placeholder="请输入新的密码" />
                </el-form-item>
                <el-form-item prop="surePwd">
                  <span style="color: #666; font-size: 20px">重置密码</span>
                  <el-input name="password" :type="passwordType" v-model="modifyForm.surePwd" @blur="surePwdInput" placeholder="请再次输入新密码，保持一致" autocomplete="on" show-password />
                </el-form-item>

                <div style="width: 100%; display: flex; justify-content: center">
                  <el-button type="primary" style="
                      margin-top: 30px;
                      width: 340px;
                      height: 60px;
                      border-radius: 38px;
                    " :loading="loading" @click="modifyPwdRulesBtn('modifyForm')">
                    {{ loginStatus == 1 ? "登录" : "确定" }}
                  </el-button>
                </div>
                <div class="remember" v-if="loginStatus == 1">
                  <el-checkbox v-model="checked">记住密码</el-checkbox>
                </div>
              </div>
            </el-form>
            <!-- 忘记密码 -->
            <el-form style="width: 350px" autocomplete="on" :rules="PhoneRules" :model="phoneForm" ref="phoneForm" label-position="left" v-if="loginStatus == 2">
              <div v-show="loginWay !== 'wx'">
                <div class="title-container">
                  <div class="title">忘记密码</div>
                </div>

                <el-form-item prop="phoneNum">
                  <span style="color: #666; font-size: 20px">手机号码</span>

                  <div class="phoneNum">
                    <div class="num86">+86</div>
                    <el-input v-model="phoneForm.phoneNum" autocomplete="on" placeholder="请输工号绑定的手机号" />
                  </div>
                </el-form-item>
                <el-form-item prop="phonecode" style="margin-bottom: 120px">
                  <span style="color: #666; font-size: 20px">验证码</span>
                  <div class="verCode">
                    <el-input v-model="phoneForm.phonecode" autocomplete="on" placeholder="请输手机收到的验证码" style="margin-right:20px" />
                    <div class="verName">
                      <span v-if="timeFlag" @click="timeJJJ">发验证码</span>
                      <span v-else> {{timeJ}} s</span>
                    </div>
                  </div>
                </el-form-item>

                <div style="width: 100%; display: flex; justify-content: center">
                  <el-button type="primary" style="
                      margin-top: 30px;
                      width: 340px;
                      height: 60px;
                      border-radius: 38px;
                    " :loading="loading" @click="verificationBtn('phoneForm')">
                    {{ loginStatus == 1 ? "登录" : "确定" }}
                  </el-button>
                </div>
                <div class="remember" v-if="loginStatus == 1">
                  <el-checkbox v-model="checked">记住密码</el-checkbox>
                </div>
              </div>
            </el-form>

            <div class="tabPane" v-if="loginStatus == 1">
              <div v-for="(v, i) in tabList" :key="i" class="ShiftTime" :class="current == i ? 'currentShiftTime' : ''" @click="checkShift(v,i)">
                <span>{{ v.name }} </span>
                <span v-if="current == i"> {{ v.time }} </span>
              </div>
            </div>
          </el-card>
        </div>

      </div>
      <div class="bottomBG">
        <div style="cursor: pointer" v-if="loginStatus !== 1" @click="loginStatus = 1">
          返回登录
        </div>
        <div style="cursor: pointer" v-if="loginStatus == 1">
          <span @click="loginStatus = 2">忘记密码</span>
          <span>丨</span>
          <span @click="loginStatusBtn">修改密码</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Qs from 'qs'
export default {
  name: "login",

  data() {
    return {
      rules: {
        hotelCode: [
          { required: true, message: '请输入酒店ID', trigger: 'change' },
        ],
        username: [
          { required: true, message: '请输入工号', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ],

      },
      PhoneRules: {
        phoneNum: [
          {
            required: true, message: '请输入手机号', trigger: 'blur'
          }
        ],
        phonecode: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ],

      },
      modifyPwdRules: {
        phoneNum: [
          {
            required: true, message: '请输入手机号', trigger: 'blur'
          }
        ],
        phonecode: [
          { required: true, message: '请输入验证码', trigger: 'change' }
        ],

      },
      passwordType: 'password',
      timeFlag: true,
      loading: false,
      timeJ: 60,
      loginStatus: 1,
      current: 0,
      //记住密码
      checked: true,
      loginWay: "11",
      loginForm: { password: "", username: "", hotelCode: '', shift: '1', posCode: '' },
      phoneForm: {
        phoneNum: '',
        phonecode: ''
      },
      modifyForm: {
        newPwd: '',
        oldPwd: '',
        surePwd: ''
      },
      tabPosition: "left",
      tabList: [
        { name: "早班", },
        { name: "中班", },
        { name: "晚班", },
        { name: "夜班", },
      ],
    };
  },
  created() {
    if (this.checked) {
      this.loginForm.password = localStorage.getItem('password', this.loginForm.password);
      this.loginForm.hotelCode = localStorage.getItem('hotelCode', this.loginForm.hotelCode);
      this.loginForm.username = localStorage.getItem('username', this.loginForm.username);

    }
  },
  computed: {},
  methods: {
    surePwdInput() {
      if (this.modifyForm.surePwd !== this.modifyForm.newPwd) {
        this.$notify.error({
          title: '与旧密码不一致'
        });
      }
    },
    posCode() {
      this.$confirm(`当前登录的站点为：${localStorage.getItem('posCode')}`, '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showCancelButton: false,
        center: true
      }).then(() => {

      })
    },
    loginStatusBtn() {
      if (!this.loginForm.hotelCode) {
        this.$notify.error({
          title: '酒店ID不能为空'
        });
      } else if (!this.loginForm.username) {
        this.$notify.error({
          title: '工号不能为空'
        });
      } else {
        this.loginStatus = 3
      }
    },
    handleLogin(loginForm) {
      this.$refs[loginForm].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('posCode')) {
            this.loginForm.posCode = localStorage.getItem('posCode')
          }
          let data = Qs.stringify(this.loginForm)
          this.$axios({
            methods: "post",
            url: this.api.getToken,
            data
          }).then(res => {
            console.log(res.data);
            if (res.data.status == 0) {
              if (this.checked) {
                // 存账号
                localStorage.setItem('businessDate', res.data.data.businessDate);
                localStorage.setItem('posDescription', res.data.data.posDescription);
                localStorage.setItem('hotel', JSON.stringify(res.data.data.hotel));
                localStorage.setItem('user', JSON.stringify(res.data.data.user));
                localStorage.setItem('username', this.loginForm.username);
                localStorage.setItem('password', this.loginForm.password);
                localStorage.setItem('shift', this.loginForm.shift);
                localStorage.setItem('posCode', this.loginForm.posCode);
                localStorage.setItem('hotelCode', this.loginForm.hotelCode);
                localStorage.removeItem('openTaiUstatus')
                this.$bus.$emit('mq2', 1)

              }
              // 提示消息
              // this.$notify.success({
              //   title: '登陆成功'
              // });
              // 存token
              localStorage.setItem('token', res.data.data.token);

              // 跳转
              this.$router.push({
                name: 'dashboard'
              })
            } else {
              this.$notify.error({
                title: res.data.message
              });
            }
            console.log(res)

          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });


    },
    verificationBtn(phoneForm) {
      if (/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.phoneForm.phoneNum) == false) {
        this.$message.error('手机号不正确!');
        return
      }
      this.$refs[phoneForm].validate((valid) => {
        if (valid) {
          this.$axios({
            methods: "get",
            url: this.api.verificationPhoneCode + '?phone=' + this.phoneForm.phoneNum + '&code=' + this.phoneForm.phonecode,

          }).then(res => {
            if (res.data.message == '验证码过期') {
              this.$notify.error({
                title: '验证码过期'
              });
            } else if (res.data.message == '验证通过') {
              this.$notify.success({
                title: '验证通过'
              });
              this.loginStatus = 3
            }

          }).catch(err => {

          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });


    },
    modifyPwdRulesBtn(modifyForm) {
      if (this.modifyForm.surePwd !== this.modifyForm.newPwd) {
        this.$notify.error({
          title: '与旧密码不一致'
        });
        return

      }
      this.$refs[modifyForm].validate((valid) => {
        if (valid) {
          let data = {
            hotelCode: this.loginForm.hotelCode,
            username: this.loginForm.username,
            oldPassword: this.modifyForm.oldPwd,
            newPassword: this.modifyForm.newPwd,
          }
          data = Qs.stringify(data)
          this.$axios({
            methods: "post",
            url: this.api.modifyPwd,
            data

          }).then(res => {
            console.log(res);
            if (res.data.status == 0) {
              this.$notify.success({
                title: '密码修改成功'
              });
              this.loginStatus = 1
            } else {
              this.$notify.error({
                title: res.data.message
              });
            }
          }).catch(err => {
            this.$notify.error({
              title: '用户名或者密码错误'
            });
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    timeJJJ() {
      this.$axios({
        methods: "get",
        url: this.api.getPhoneCode + '?phone=' + this.phoneForm.phoneNum,
      }).then(res => {

        console.log(res)
        this.$notify.success({
          title: '验证码发送成功'
        });
      }).catch(err => {
        this.$notify.success({
          title: res.data.message
        });
      })

      let timeID = setInterval(() => {
        this.timeJ--
        this.timeFlag = false
        if (this.timeJ == 0) {
          clearInterval(timeID)
          this.timeFlag = true
          this.timeJ = 60;
        }
      }, 1000)
    },
    checkShift(v, i) {
      this.current = i;
      this.loginForm.shift = i + 1
      console.log(this.loginForm);
    },
    handleNumberLogin() {
      console.log(1);
    },
  },

  destroyed() {
    // window.removeEventListener('hashchange', this.afterQRScan)
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.el-input {
  font-size: 20px;
}
/deep/.el-input__inner {
  background: #eeeeee;
}
.mainBG {
  width: 100%;
  background-color: #80c7ff;
  height: 100%;

  .bottomBG {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 535px;
    background-image: url("./../../assets/imgs/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    z-index: inherit;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 40px;
    color: #999;
  }
}
.phoneNum {
  display: flex;
  .num86 {
    display: flex;
    border: 1px solid #dcdfe6;
    border-radius: 6px  0px  0px  6px;
    width: 100px;
    height: 66px;
    background: #eeeeee;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin-right: 2px;
  }
}
.verCode {
  display: flex;
  align-items: center;
  .verName {
    color: #0099ff;
    font-size: 20px;
    width: 120px;
    span:nth-child(1) {
      cursor: pointer;
    }
  }
}
.login-container {
  // position: fixed;
  // height: 100%;
  height: 100vh;
  width: 100%;
  // background-image: url("./../../assets/login/bg.jpg");
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  padding-left: 8%;
  padding-right: 13%;
  .login_card {
    margin-top: 7%;
    position: relative;
    height: 650px;
    width: 460px;
    display: flex;
    // padding: 0 40px;
    justify-content: center;
    border-radius: 15px;
    overflow: inherit !important;
    z-index: 100;
  }

  .bottom {
    position: absolute;
    right: 0;
    left: 0;
    // background: rgba(0, 0, 0, 1);
    opacity: 0.7;
    bottom: 00px;
    .bottom_content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 90px;
      font-size: 12px;
      font-weight: 400;
      // color: rgba(153, 153, 153, 1) !important;
      color: #fff;
    }
  }

  .title-container {
    position: relative;
    .title {
      height: 32px;
      line-height: 32px;
      margin: 40px auto 30px auto;
      text-align: center;
      font-size: 28px;
      color: #0099ff;
    }
    .set-language {
      color: #fff;
      position: absolute;
      top: 5px;
      right: 0px;
    }
  }
  .tabPane {
    position: absolute;
    top: 50px;
    left: -121px;
    z-index: 1000000;
    .ShiftTime {
      height: 60px;
      width: 120px;
      background: #b6dfff;
      border-radius: 10px 0 0 10px;
      margin-top: 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      span:nth-child(1) {
        font-size: 24px;
        color: #0099ff;
      }
      span:nth-child(2) {
        font-size: 14px;
        color: #999999;
      }
    }
    .currentShiftTime {
      width: 160px;
      height: 80px;
      background: #fff;
      position: relative;
      top: 0;
      left: -40px;
    }
  }

  .thirdparty-button {
    position: absolute;
    right: 35px;
    bottom: 28px;
  }
}
.remember {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
/deep/.el-checkbox__label {
  color: #666666 !important;
  font-size: 20px;
}
/deep/.el-checkbox__inner {
  width: 22px;
  height: 22px;
  border: 1px solid #fe8d30 !important;
  border-radius: 11px;
}
/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: #fe8d30 !important;
}
/deep/.el-checkbox__inner::after {
  box-sizing: content-box;
  content: "";
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 11px;
  left: 6px;
  position: absolute;
  top: 2px;
  transform: rotate(45deg) scaleY(0);
  width: 8px;
  transition: transform 0.15s ease-in 0.05s;
  transform-origin: center;
}
/deep/.el-input__inner {
  line-height: 66px;
  height: 66px !important;
  // width: 340px !important;
}
/deep/.el-form-item {
  margin-bottom: 10px;
}
/deep/.el-button--primary {
  background: -webkit-gradient(
    linear,
    0 0,
    0 100%,
    from(#ffbe34),
    to(#fe812f)
  ) !important;
  border: 0;
  font-size: 28px;

  font-weight: 400;
}
</style>


